
export const BASE_URL = (import.meta.env.VITE_REACT_APP_CORE_ENGINE_URL || '').trim()

// Configuration constants
export const config = {
  // Core Engine
  CORE_ENGINE_URL: (import.meta.env.VITE_REACT_APP_CORE_ENGINE_URL || '').trim(),
  BASIC_AUTH_TOKEN: (import.meta.env.VITE_REACT_APP_BASIC_AUTH_TOKEN || '').trim(),
  
  // Google Maps
  GOOGLE_MAP_JAVASCRIPT_API_KEY: (import.meta.env.VITE_REACT_APP_GOOGLE_MAP_JAVASCRIPT_API_KEY || '').trim(),
  GOOGLE_MAP_GEOCODING_API_KEY: (import.meta.env.VITE_REACT_APP_GOOGLE_MAP_GEOCODING_API_KEY || '').trim(),

  // Gift API
  GIFT_API_BASE_URL: (import.meta.env.VITE_REACT_APP_GIFT_API_BASE_URL || '').trim(),
  GIFT_API_KEY: (import.meta.env.VITE_REACT_APP_GIFT_API_KEY || '').trim(),

  // Blockchain
  BLOCKCHAIN_EXPLORER_URL: (import.meta.env.VITE_BLOCKCHAIN_EXPLORER_URL || '').trim(),
  
  // Build configuration
  GENERATE_SOURCEMAP: false,
  DISABLE_ESLINT_PLUGIN: true,
  PORT: 3000
}
